// extracted by mini-css-extract-plugin
export default {"root":"IconBrowser_root__ab-4E"};